export default __webpack_public_path__ + "static/media/gift.4bb4ca47.png";